/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConfigurationSyncItemsResponse } from './ConfigurationSyncItemsResponse';
import {
    ConfigurationSyncItemsResponseFromJSON,
    ConfigurationSyncItemsResponseFromJSONTyped,
    ConfigurationSyncItemsResponseToJSON,
    ConfigurationSyncItemsResponseToJSONTyped,
} from './ConfigurationSyncItemsResponse';

/**
 * 
 * @export
 * @interface ConfigurationSyncResponse
 */
export interface ConfigurationSyncResponse {
    /**
     * 
     * @type {Date}
     * @memberof ConfigurationSyncResponse
     */
    serverTimeUtc?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ConfigurationSyncResponse
     */
    isFullSync?: boolean;
    /**
     * 
     * @type {ConfigurationSyncItemsResponse}
     * @memberof ConfigurationSyncResponse
     */
    syncItems?: ConfigurationSyncItemsResponse;
}

/**
 * Check if a given object implements the ConfigurationSyncResponse interface.
 */
export function instanceOfConfigurationSyncResponse(value: object): value is ConfigurationSyncResponse {
    return true;
}

export function ConfigurationSyncResponseFromJSON(json: any): ConfigurationSyncResponse {
    return ConfigurationSyncResponseFromJSONTyped(json, false);
}

export function ConfigurationSyncResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigurationSyncResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'serverTimeUtc': json['serverTimeUtc'] == null ? undefined : (new Date(json['serverTimeUtc'])),
        'isFullSync': json['isFullSync'] == null ? undefined : json['isFullSync'],
        'syncItems': json['syncItems'] == null ? undefined : ConfigurationSyncItemsResponseFromJSON(json['syncItems']),
    };
}

export function ConfigurationSyncResponseToJSON(json: any): ConfigurationSyncResponse {
    return ConfigurationSyncResponseToJSONTyped(json, false);
}

export function ConfigurationSyncResponseToJSONTyped(value?: ConfigurationSyncResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'serverTimeUtc': value['serverTimeUtc'] == null ? undefined : ((value['serverTimeUtc']).toISOString()),
        'isFullSync': value['isFullSync'],
        'syncItems': ConfigurationSyncItemsResponseToJSON(value['syncItems']),
    };
}

